import _last from "lodash/last.js";
import _includes from "lodash/includes.js";
import _get from "lodash/get.js";
function cov_25bxqxe5o4() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Input/helpers.ts";
  var hash = "9061f879f06d761431a15347495d4a2fae637557";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Input/helpers.ts",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 40
        },
        end: {
          line: 10,
          column: 76
        }
      },
      "1": {
        start: {
          line: 12,
          column: 43
        },
        end: {
          line: 12,
          column: 52
        }
      },
      "2": {
        start: {
          line: 14,
          column: 28
        },
        end: {
          line: 14,
          column: 37
        }
      },
      "3": {
        start: {
          line: 15,
          column: 37
        },
        end: {
          line: 15,
          column: 57
        }
      },
      "4": {
        start: {
          line: 16,
          column: 34
        },
        end: {
          line: 16,
          column: 63
        }
      },
      "5": {
        start: {
          line: 18,
          column: 39
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "6": {
        start: {
          line: 41,
          column: 32
        },
        end: {
          line: 41,
          column: 76
        }
      },
      "7": {
        start: {
          line: 43,
          column: 21
        },
        end: {
          line: 59,
          column: 1
        }
      },
      "8": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 58,
          column: 5
        }
      },
      "9": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 57,
          column: 7
        }
      },
      "10": {
        start: {
          line: 48,
          column: 19
        },
        end: {
          line: 48,
          column: 30
        }
      },
      "11": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 54,
          column: 9
        }
      },
      "12": {
        start: {
          line: 51,
          column: 10
        },
        end: {
          line: 51,
          column: 77
        }
      },
      "13": {
        start: {
          line: 53,
          column: 10
        },
        end: {
          line: 53,
          column: 22
        }
      },
      "14": {
        start: {
          line: 61,
          column: 34
        },
        end: {
          line: 67,
          column: 1
        }
      },
      "15": {
        start: {
          line: 64,
          column: 16
        },
        end: {
          line: 64,
          column: 85
        }
      },
      "16": {
        start: {
          line: 65,
          column: 21
        },
        end: {
          line: 65,
          column: 46
        }
      },
      "17": {
        start: {
          line: 66,
          column: 2
        },
        end: {
          line: 66,
          column: 31
        }
      },
      "18": {
        start: {
          line: 69,
          column: 32
        },
        end: {
          line: 72,
          column: 1
        }
      },
      "19": {
        start: {
          line: 70,
          column: 16
        },
        end: {
          line: 70,
          column: 55
        }
      },
      "20": {
        start: {
          line: 71,
          column: 2
        },
        end: {
          line: 71,
          column: 34
        }
      },
      "21": {
        start: {
          line: 74,
          column: 35
        },
        end: {
          line: 89,
          column: 1
        }
      },
      "22": {
        start: {
          line: 79,
          column: 14
        },
        end: {
          line: 79,
          column: 18
        }
      },
      "23": {
        start: {
          line: 80,
          column: 20
        },
        end: {
          line: 80,
          column: 73
        }
      },
      "24": {
        start: {
          line: 81,
          column: 19
        },
        end: {
          line: 81,
          column: 40
        }
      },
      "25": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 84,
          column: 3
        }
      },
      "26": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 18
        }
      },
      "27": {
        start: {
          line: 85,
          column: 2
        },
        end: {
          line: 87,
          column: 3
        }
      },
      "28": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 18
        }
      },
      "29": {
        start: {
          line: 88,
          column: 2
        },
        end: {
          line: 88,
          column: 15
        }
      },
      "30": {
        start: {
          line: 91,
          column: 29
        },
        end: {
          line: 102,
          column: 1
        }
      },
      "31": {
        start: {
          line: 92,
          column: 20
        },
        end: {
          line: 92,
          column: 73
        }
      },
      "32": {
        start: {
          line: 93,
          column: 18
        },
        end: {
          line: 93,
          column: 62
        }
      },
      "33": {
        start: {
          line: 97,
          column: 26
        },
        end: {
          line: 100,
          column: 71
        }
      },
      "34": {
        start: {
          line: 101,
          column: 2
        },
        end: {
          line: 101,
          column: 25
        }
      },
      "35": {
        start: {
          line: 104,
          column: 28
        },
        end: {
          line: 114,
          column: 1
        }
      },
      "36": {
        start: {
          line: 105,
          column: 20
        },
        end: {
          line: 105,
          column: 73
        }
      },
      "37": {
        start: {
          line: 106,
          column: 18
        },
        end: {
          line: 106,
          column: 62
        }
      },
      "38": {
        start: {
          line: 110,
          column: 26
        },
        end: {
          line: 112,
          column: 65
        }
      },
      "39": {
        start: {
          line: 113,
          column: 2
        },
        end: {
          line: 113,
          column: 25
        }
      },
      "40": {
        start: {
          line: 116,
          column: 35
        },
        end: {
          line: 120,
          column: 1
        }
      },
      "41": {
        start: {
          line: 118,
          column: 19
        },
        end: {
          line: 118,
          column: 84
        }
      },
      "42": {
        start: {
          line: 119,
          column: 2
        },
        end: {
          line: 119,
          column: 61
        }
      },
      "43": {
        start: {
          line: 122,
          column: 27
        },
        end: {
          line: 162,
          column: 1
        }
      },
      "44": {
        start: {
          line: 123,
          column: 17
        },
        end: {
          line: 123,
          column: 20
        }
      },
      "45": {
        start: {
          line: 124,
          column: 2
        },
        end: {
          line: 126,
          column: 3
        }
      },
      "46": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 20
        }
      },
      "47": {
        start: {
          line: 128,
          column: 2
        },
        end: {
          line: 160,
          column: 3
        }
      },
      "48": {
        start: {
          line: 132,
          column: 6
        },
        end: {
          line: 148,
          column: 7
        }
      },
      "49": {
        start: {
          line: 140,
          column: 10
        },
        end: {
          line: 140,
          column: 94
        }
      },
      "50": {
        start: {
          line: 142,
          column: 8
        },
        end: {
          line: 142,
          column: 55
        }
      },
      "51": {
        start: {
          line: 143,
          column: 22
        },
        end: {
          line: 143,
          column: 43
        }
      },
      "52": {
        start: {
          line: 144,
          column: 8
        },
        end: {
          line: 147,
          column: 9
        }
      },
      "53": {
        start: {
          line: 145,
          column: 65
        },
        end: {
          line: 145,
          column: 77
        }
      },
      "54": {
        start: {
          line: 146,
          column: 10
        },
        end: {
          line: 146,
          column: 73
        }
      },
      "55": {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 149,
          column: 12
        }
      },
      "56": {
        start: {
          line: 151,
          column: 6
        },
        end: {
          line: 151,
          column: 56
        }
      },
      "57": {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 152,
          column: 12
        }
      },
      "58": {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 154,
          column: 55
        }
      },
      "59": {
        start: {
          line: 155,
          column: 6
        },
        end: {
          line: 155,
          column: 12
        }
      },
      "60": {
        start: {
          line: 157,
          column: 6
        },
        end: {
          line: 157,
          column: 66
        }
      },
      "61": {
        start: {
          line: 158,
          column: 6
        },
        end: {
          line: 158,
          column: 12
        }
      },
      "62": {
        start: {
          line: 161,
          column: 2
        },
        end: {
          line: 161,
          column: 18
        }
      },
      "63": {
        start: {
          line: 164,
          column: 31
        },
        end: {
          line: 167,
          column: 1
        }
      },
      "64": {
        start: {
          line: 165,
          column: 23
        },
        end: {
          line: 165,
          column: 90
        }
      },
      "65": {
        start: {
          line: 166,
          column: 2
        },
        end: {
          line: 166,
          column: 33
        }
      },
      "66": {
        start: {
          line: 169,
          column: 29
        },
        end: {
          line: 191,
          column: 1
        }
      },
      "67": {
        start: {
          line: 170,
          column: 17
        },
        end: {
          line: 170,
          column: 20
        }
      },
      "68": {
        start: {
          line: 171,
          column: 2
        },
        end: {
          line: 173,
          column: 3
        }
      },
      "69": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 172,
          column: 20
        }
      },
      "70": {
        start: {
          line: 175,
          column: 2
        },
        end: {
          line: 189,
          column: 3
        }
      },
      "71": {
        start: {
          line: 178,
          column: 26
        },
        end: {
          line: 178,
          column: 68
        }
      },
      "72": {
        start: {
          line: 179,
          column: 6
        },
        end: {
          line: 179,
          column: 75
        }
      },
      "73": {
        start: {
          line: 180,
          column: 6
        },
        end: {
          line: 180,
          column: 12
        }
      },
      "74": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 182,
          column: 50
        }
      },
      "75": {
        start: {
          line: 183,
          column: 6
        },
        end: {
          line: 183,
          column: 12
        }
      },
      "76": {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 186,
          column: 74
        }
      },
      "77": {
        start: {
          line: 187,
          column: 6
        },
        end: {
          line: 187,
          column: 12
        }
      },
      "78": {
        start: {
          line: 190,
          column: 2
        },
        end: {
          line: 190,
          column: 18
        }
      },
      "79": {
        start: {
          line: 201,
          column: 49
        },
        end: {
          line: 206,
          column: 1
        }
      },
      "80": {
        start: {
          line: 202,
          column: 23
        },
        end: {
          line: 202,
          column: 61
        }
      },
      "81": {
        start: {
          line: 204,
          column: 4
        },
        end: {
          line: 204,
          column: 93
        }
      },
      "82": {
        start: {
          line: 205,
          column: 2
        },
        end: {
          line: 205,
          column: 44
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 43,
            column: 21
          },
          end: {
            line: 43,
            column: 22
          }
        },
        loc: {
          start: {
            line: 43,
            column: 57
          },
          end: {
            line: 59,
            column: 1
          }
        },
        line: 43
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 44,
            column: 21
          },
          end: {
            line: 44,
            column: 22
          }
        },
        loc: {
          start: {
            line: 44,
            column: 34
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 44
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 48,
            column: 13
          },
          end: {
            line: 48,
            column: 14
          }
        },
        loc: {
          start: {
            line: 48,
            column: 19
          },
          end: {
            line: 48,
            column: 30
          }
        },
        line: 48
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 49,
            column: 17
          },
          end: {
            line: 49,
            column: 18
          }
        },
        loc: {
          start: {
            line: 49,
            column: 33
          },
          end: {
            line: 55,
            column: 7
          }
        },
        line: 49
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 61,
            column: 34
          },
          end: {
            line: 61,
            column: 35
          }
        },
        loc: {
          start: {
            line: 63,
            column: 54
          },
          end: {
            line: 67,
            column: 1
          }
        },
        line: 63
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 69,
            column: 32
          },
          end: {
            line: 69,
            column: 33
          }
        },
        loc: {
          start: {
            line: 69,
            column: 60
          },
          end: {
            line: 72,
            column: 1
          }
        },
        line: 69
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 74,
            column: 35
          },
          end: {
            line: 74,
            column: 36
          }
        },
        loc: {
          start: {
            line: 78,
            column: 14
          },
          end: {
            line: 89,
            column: 1
          }
        },
        line: 78
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 91,
            column: 29
          },
          end: {
            line: 91,
            column: 30
          }
        },
        loc: {
          start: {
            line: 91,
            column: 79
          },
          end: {
            line: 102,
            column: 1
          }
        },
        line: 91
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 104,
            column: 28
          },
          end: {
            line: 104,
            column: 29
          }
        },
        loc: {
          start: {
            line: 104,
            column: 78
          },
          end: {
            line: 114,
            column: 1
          }
        },
        line: 104
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 116,
            column: 35
          },
          end: {
            line: 116,
            column: 36
          }
        },
        loc: {
          start: {
            line: 116,
            column: 85
          },
          end: {
            line: 120,
            column: 1
          }
        },
        line: 116
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 122,
            column: 27
          },
          end: {
            line: 122,
            column: 28
          }
        },
        loc: {
          start: {
            line: 122,
            column: 89
          },
          end: {
            line: 162,
            column: 1
          }
        },
        line: 122
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 164,
            column: 31
          },
          end: {
            line: 164,
            column: 32
          }
        },
        loc: {
          start: {
            line: 164,
            column: 58
          },
          end: {
            line: 167,
            column: 1
          }
        },
        line: 164
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 169,
            column: 29
          },
          end: {
            line: 169,
            column: 30
          }
        },
        loc: {
          start: {
            line: 169,
            column: 68
          },
          end: {
            line: 191,
            column: 1
          }
        },
        line: 169
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 201,
            column: 49
          },
          end: {
            line: 201,
            column: 50
          }
        },
        loc: {
          start: {
            line: 201,
            column: 76
          },
          end: {
            line: 206,
            column: 1
          }
        },
        line: 201
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 54,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 54,
            column: 9
          }
        }, {
          start: {
            line: 52,
            column: 15
          },
          end: {
            line: 54,
            column: 9
          }
        }],
        line: 50
      },
      "1": {
        loc: {
          start: {
            line: 64,
            column: 16
          },
          end: {
            line: 64,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 16
          },
          end: {
            line: 64,
            column: 67
          }
        }, {
          start: {
            line: 64,
            column: 71
          },
          end: {
            line: 64,
            column: 85
          }
        }],
        line: 64
      },
      "2": {
        loc: {
          start: {
            line: 71,
            column: 9
          },
          end: {
            line: 71,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 9
          },
          end: {
            line: 71,
            column: 14
          }
        }, {
          start: {
            line: 71,
            column: 18
          },
          end: {
            line: 71,
            column: 33
          }
        }],
        line: 71
      },
      "3": {
        loc: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 82
      },
      "4": {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 14
          }
        }, {
          start: {
            line: 82,
            column: 18
          },
          end: {
            line: 82,
            column: 37
          }
        }],
        line: 82
      },
      "5": {
        loc: {
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 85
      },
      "6": {
        loc: {
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 85,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 85,
            column: 14
          }
        }, {
          start: {
            line: 85,
            column: 18
          },
          end: {
            line: 85,
            column: 37
          }
        }],
        line: 85
      },
      "7": {
        loc: {
          start: {
            line: 100,
            column: 12
          },
          end: {
            line: 100,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 100,
            column: 41
          },
          end: {
            line: 100,
            column: 42
          }
        }, {
          start: {
            line: 100,
            column: 45
          },
          end: {
            line: 100,
            column: 70
          }
        }],
        line: 100
      },
      "8": {
        loc: {
          start: {
            line: 112,
            column: 12
          },
          end: {
            line: 112,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 112,
            column: 41
          },
          end: {
            line: 112,
            column: 42
          }
        }, {
          start: {
            line: 112,
            column: 45
          },
          end: {
            line: 112,
            column: 64
          }
        }],
        line: 112
      },
      "9": {
        loc: {
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 126,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 126,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 124
      },
      "10": {
        loc: {
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 124,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 124,
            column: 15
          }
        }, {
          start: {
            line: 124,
            column: 19
          },
          end: {
            line: 124,
            column: 40
          }
        }],
        line: 124
      },
      "11": {
        loc: {
          start: {
            line: 128,
            column: 2
          },
          end: {
            line: 160,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 149,
            column: 12
          }
        }, {
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 152,
            column: 12
          }
        }, {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 155,
            column: 12
          }
        }, {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 158,
            column: 12
          }
        }, {
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 159,
            column: 12
          }
        }],
        line: 128
      },
      "12": {
        loc: {
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 148,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 148,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 132
      },
      "13": {
        loc: {
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 132,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 132,
            column: 31
          }
        }, {
          start: {
            line: 132,
            column: 35
          },
          end: {
            line: 132,
            column: 55
          }
        }],
        line: 132
      },
      "14": {
        loc: {
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 144
      },
      "15": {
        loc: {
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 171
      },
      "16": {
        loc: {
          start: {
            line: 171,
            column: 6
          },
          end: {
            line: 171,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 171,
            column: 6
          },
          end: {
            line: 171,
            column: 15
          }
        }, {
          start: {
            line: 171,
            column: 19
          },
          end: {
            line: 171,
            column: 40
          }
        }],
        line: 171
      },
      "17": {
        loc: {
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 189,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 180,
            column: 12
          }
        }, {
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 183,
            column: 12
          }
        }, {
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 184,
            column: 18
          }
        }, {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 187,
            column: 12
          }
        }, {
          start: {
            line: 188,
            column: 4
          },
          end: {
            line: 188,
            column: 12
          }
        }],
        line: 175
      },
      "18": {
        loc: {
          start: {
            line: 179,
            column: 18
          },
          end: {
            line: 179,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 179,
            column: 32
          },
          end: {
            line: 179,
            column: 58
          }
        }, {
          start: {
            line: 179,
            column: 61
          },
          end: {
            line: 179,
            column: 63
          }
        }],
        line: 179
      },
      "19": {
        loc: {
          start: {
            line: 204,
            column: 4
          },
          end: {
            line: 204,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 204,
            column: 37
          },
          end: {
            line: 204,
            column: 62
          }
        }, {
          start: {
            line: 204,
            column: 65
          },
          end: {
            line: 204,
            column: 93
          }
        }],
        line: 204
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0, 0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0, 0, 0, 0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9061f879f06d761431a15347495d4a2fae637557"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_25bxqxe5o4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_25bxqxe5o4();
import * as Mailcheck from 'mailcheck';
import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js';
/* no-es-lib-transform - prevent mortar from breaking this path */
import isEmail from 'validator/lib/isEmail.js';
import { centsToCurrencyString } from "../../helpers/currencyHelpers.mjs";
const mailcheckDefaultTopLevelDomains = (cov_25bxqxe5o4().s[0]++, ['com', 'net', 'org', 'info', 'edu']);
const stripDollarCommaPercentPunctuation = (cov_25bxqxe5o4().s[1]++, /\$|,|%/g);
const stripNonDigitPeriod = (cov_25bxqxe5o4().s[2]++, /[^\d.]/g);
const commaPositionsWithoutDecimal = (cov_25bxqxe5o4().s[3]++, /\d(?=(?:\d{3})+$)/g);
const commaPositionsWithDecimal = (cov_25bxqxe5o4().s[4]++, /\d(?=(?:\d{3})+(?:\.\d*)$)/g);
export const mailcheckDefaultDomains = (cov_25bxqxe5o4().s[5]++, [
// Keep in sync with app/services/BriteVerifyService
'yahoo.com', 'google.com', 'hotmail.com', 'gmail.com', 'me.com', 'aol.com', 'mac.com', 'live.com', 'comcast.net', 'googlemail.com', 'msn.com', 'facebook.com', 'verizon.net', 'sbcglobal.net', 'att.net', 'mail.com', 'outlook.com', 'icloud.com', 'cox.net']);
export const BLACKLISTED_TLDS = (cov_25bxqxe5o4().s[6]++, ['como', 'comp', 'con', 'met', 'ner', 'vom']);
cov_25bxqxe5o4().s[7]++;
const suggestEmail = email => {
  cov_25bxqxe5o4().f[0]++;
  cov_25bxqxe5o4().s[8]++;
  return new Promise(resolve => {
    cov_25bxqxe5o4().f[1]++;
    cov_25bxqxe5o4().s[9]++;
    Mailcheck.run({
      domains: mailcheckDefaultDomains,
      email,
      empty: () => {
        cov_25bxqxe5o4().f[2]++;
        cov_25bxqxe5o4().s[10]++;
        return resolve('');
      },
      suggested: suggestion => {
        cov_25bxqxe5o4().f[3]++;
        cov_25bxqxe5o4().s[11]++;
        if (_includes(_get(suggestion, 'domain'), '.')) {
          cov_25bxqxe5o4().b[0][0]++;
          cov_25bxqxe5o4().s[12]++;
          resolve(JSON.stringify(_get(suggestion, 'full')).replace(/"/g, ''));
        } else {
          cov_25bxqxe5o4().b[0][1]++;
          cov_25bxqxe5o4().s[13]++;
          resolve('');
        }
      },
      topLevelDomains: mailcheckDefaultTopLevelDomains
    });
  });
};
cov_25bxqxe5o4().s[14]++;
export const checkEmailValidity = async value => {
  cov_25bxqxe5o4().f[4]++;
  const valid = (cov_25bxqxe5o4().s[15]++, (cov_25bxqxe5o4().b[1][0]++, !_includes(BLACKLISTED_TLDS, _last(value.split('.')))) && (cov_25bxqxe5o4().b[1][1]++, isEmail(value)));
  const suggestion = (cov_25bxqxe5o4().s[16]++, await suggestEmail(value));
  cov_25bxqxe5o4().s[17]++;
  return {
    valid,
    suggestion
  };
};
cov_25bxqxe5o4().s[18]++;
export const checkTelValidity = value => {
  cov_25bxqxe5o4().f[5]++;
  const phone = (cov_25bxqxe5o4().s[19]++, parsePhoneNumberFromString(value, 'US'));
  cov_25bxqxe5o4().s[20]++;
  return (cov_25bxqxe5o4().b[2][0]++, phone) && (cov_25bxqxe5o4().b[2][1]++, phone.isValid());
};
cov_25bxqxe5o4().s[21]++;
export const checkNumberValidity = (value, minValue, maxValue) => {
  cov_25bxqxe5o4().f[6]++;
  let valid = (cov_25bxqxe5o4().s[22]++, true);
  const parsedNum = (cov_25bxqxe5o4().s[23]++, value.replace(stripDollarCommaPercentPunctuation, ''));
  const numValue = (cov_25bxqxe5o4().s[24]++, parseFloat(parsedNum));
  cov_25bxqxe5o4().s[25]++;
  if ((cov_25bxqxe5o4().b[4][0]++, minValue) && (cov_25bxqxe5o4().b[4][1]++, minValue > numValue)) {
    cov_25bxqxe5o4().b[3][0]++;
    cov_25bxqxe5o4().s[26]++;
    valid = false;
  } else {
    cov_25bxqxe5o4().b[3][1]++;
  }
  cov_25bxqxe5o4().s[27]++;
  if ((cov_25bxqxe5o4().b[6][0]++, maxValue) && (cov_25bxqxe5o4().b[6][1]++, maxValue < numValue)) {
    cov_25bxqxe5o4().b[5][0]++;
    cov_25bxqxe5o4().s[28]++;
    valid = false;
  } else {
    cov_25bxqxe5o4().b[5][1]++;
  }
  cov_25bxqxe5o4().s[29]++;
  return valid;
};
cov_25bxqxe5o4().s[30]++;
export const formatPercent = (value, decimalPlaces) => {
  cov_25bxqxe5o4().f[7]++;
  const parsedNum = (cov_25bxqxe5o4().s[31]++, value.replace(stripDollarCommaPercentPunctuation, ''));
  const rounded = (cov_25bxqxe5o4().s[32]++, parseFloat(parsedNum).toFixed(decimalPlaces));

  // NOTE: Intl.Numberformat automatically replaces insignificant digits in the number string with zeroes
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
  const formattedNumber = (cov_25bxqxe5o4().s[33]++, new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: decimalPlaces
  }).format(isNaN(parseFloat(rounded)) ? (cov_25bxqxe5o4().b[7][0]++, 0) : (cov_25bxqxe5o4().b[7][1]++, parseFloat(rounded) / 100)));
  cov_25bxqxe5o4().s[34]++;
  return formattedNumber;
};
cov_25bxqxe5o4().s[35]++;
export const formatNumber = (value, decimalPlaces) => {
  cov_25bxqxe5o4().f[8]++;
  const parsedNum = (cov_25bxqxe5o4().s[36]++, value.replace(stripDollarCommaPercentPunctuation, ''));
  const rounded = (cov_25bxqxe5o4().s[37]++, parseFloat(parsedNum).toFixed(decimalPlaces));

  // NOTE: Intl.Numberformat automatically replaces insignificant digits in the number string with zeroes
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
  const formattedNumber = (cov_25bxqxe5o4().s[38]++, new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimalPlaces
  }).format(isNaN(parseFloat(rounded)) ? (cov_25bxqxe5o4().b[8][0]++, 0) : (cov_25bxqxe5o4().b[8][1]++, parseFloat(rounded))));
  cov_25bxqxe5o4().s[39]++;
  return formattedNumber;
};
cov_25bxqxe5o4().s[40]++;
export const formatCurrencyValue = (value, roundToCents) => {
  cov_25bxqxe5o4().f[9]++;
  // Removes '$' and ',' characters from the value string in order to parse value as a number
  const numValue = (cov_25bxqxe5o4().s[41]++, parseFloat(value.replace(stripDollarCommaPercentPunctuation, '')));
  cov_25bxqxe5o4().s[42]++;
  return centsToCurrencyString(numValue * 100, roundToCents);
};
cov_25bxqxe5o4().s[43]++;
export const formatValue = (val, type, decimalPlaces) => {
  cov_25bxqxe5o4().f[10]++;
  let newValue = (cov_25bxqxe5o4().s[44]++, val);
  cov_25bxqxe5o4().s[45]++;
  if ((cov_25bxqxe5o4().b[10][0]++, !newValue) || (cov_25bxqxe5o4().b[10][1]++, newValue.length === 0)) {
    cov_25bxqxe5o4().b[9][0]++;
    cov_25bxqxe5o4().s[46]++;
    return newValue;
  } else {
    cov_25bxqxe5o4().b[9][1]++;
  }
  cov_25bxqxe5o4().s[47]++;
  switch (type) {
    // format phone number input to the format of xxx-xxx-xxxx.
    case 'tel':
      cov_25bxqxe5o4().b[11][0]++;
      cov_25bxqxe5o4().s[48]++;
      // Prevents formatting when the changed value is just removing a parenthesis
      if (!((cov_25bxqxe5o4().b[13][0]++, newValue[0] === '(') && (cov_25bxqxe5o4().b[13][1]++, newValue.length <= 4))) {
        cov_25bxqxe5o4().b[12][0]++;
        /**
         * AsYouType format phone number into 3 ways:
         * number with + area code: +x xxx xxx xxxx.
         * number with area code: x (xxx) xxx-xxxx.
         * number without area code: (xxx) xxx-xxxx.
         */
        const regex = (cov_25bxqxe5o4().s[49]++, /(?<areaCode>[\d]{3})\)? (?<numberFirstThree>[\d]{3})[- ](?<numberLastFour>[\d]{4})/);
        cov_25bxqxe5o4().s[50]++;
        newValue = new AsYouType('US').input(newValue);
        const match = (cov_25bxqxe5o4().s[51]++, newValue.match(regex));
        cov_25bxqxe5o4().s[52]++;
        if (match) {
          cov_25bxqxe5o4().b[14][0]++;
          const {
            areaCode,
            numberFirstThree,
            numberLastFour
          } = (cov_25bxqxe5o4().s[53]++, match.groups);
          cov_25bxqxe5o4().s[54]++;
          newValue = "".concat(areaCode, "-").concat(numberFirstThree, "-").concat(numberLastFour);
        } else {
          cov_25bxqxe5o4().b[14][1]++;
        }
      } else {
        cov_25bxqxe5o4().b[12][1]++;
      }
      cov_25bxqxe5o4().s[55]++;
      break;
    case 'percent':
      cov_25bxqxe5o4().b[11][1]++;
      cov_25bxqxe5o4().s[56]++;
      newValue = formatPercent(newValue, decimalPlaces);
      cov_25bxqxe5o4().s[57]++;
      break;
    case 'number':
      cov_25bxqxe5o4().b[11][2]++;
      cov_25bxqxe5o4().s[58]++;
      newValue = formatNumber(newValue, decimalPlaces);
      cov_25bxqxe5o4().s[59]++;
      break;
    case 'currency':
      cov_25bxqxe5o4().b[11][3]++;
      cov_25bxqxe5o4().s[60]++;
      newValue = formatCurrencyValue(newValue, decimalPlaces > 0);
      cov_25bxqxe5o4().s[61]++;
      break;
    default:
      cov_25bxqxe5o4().b[11][4]++;
  }
  cov_25bxqxe5o4().s[62]++;
  return newValue;
};
cov_25bxqxe5o4().s[63]++;
const percentStringToDecimal = value => {
  cov_25bxqxe5o4().f[11]++;
  const percentValue = (cov_25bxqxe5o4().s[64]++, Number(value.replace(stripDollarCommaPercentPunctuation, '')) / 100);
  cov_25bxqxe5o4().s[65]++;
  return percentValue.toString();
};
cov_25bxqxe5o4().s[66]++;
export const unformatValue = (val, type) => {
  cov_25bxqxe5o4().f[12]++;
  let newValue = (cov_25bxqxe5o4().s[67]++, val);
  cov_25bxqxe5o4().s[68]++;
  if ((cov_25bxqxe5o4().b[16][0]++, !newValue) || (cov_25bxqxe5o4().b[16][1]++, newValue.length === 0)) {
    cov_25bxqxe5o4().b[15][0]++;
    cov_25bxqxe5o4().s[69]++;
    return newValue;
  } else {
    cov_25bxqxe5o4().b[15][1]++;
  }
  cov_25bxqxe5o4().s[70]++;
  switch (type) {
    case 'tel':
      cov_25bxqxe5o4().b[17][0]++;
      // eslint-disable-next-line no-case-declarations
      const phoneNumber = (cov_25bxqxe5o4().s[71]++, parsePhoneNumberFromString(newValue, 'US'));
      cov_25bxqxe5o4().s[72]++;
      newValue = phoneNumber ? (cov_25bxqxe5o4().b[18][0]++, phoneNumber.nationalNumber) : (cov_25bxqxe5o4().b[18][1]++, '');
      cov_25bxqxe5o4().s[73]++;
      break;
    case 'percent':
      cov_25bxqxe5o4().b[17][1]++;
      cov_25bxqxe5o4().s[74]++;
      newValue = percentStringToDecimal(newValue);
      cov_25bxqxe5o4().s[75]++;
      break;
    case 'number':
      cov_25bxqxe5o4().b[17][2]++;
    case 'currency':
      cov_25bxqxe5o4().b[17][3]++;
      cov_25bxqxe5o4().s[76]++;
      newValue = newValue.replace(stripDollarCommaPercentPunctuation, '');
      cov_25bxqxe5o4().s[77]++;
      break;
    default:
      cov_25bxqxe5o4().b[17][4]++;
  }
  cov_25bxqxe5o4().s[78]++;
  return newValue;
};

/*
  This function will strip any non digit or period characters then it will
  add commas to every third number after a decimal for added clarity while
  typing out a number in an input field.

  This does not format the value into the final output (i.e. formatValue) because
  we don't want to prematurely add decimals places to the input while typing.
*/
cov_25bxqxe5o4().s[79]++;
export const sanitizeAndFormatNumberWithCommas = value => {
  cov_25bxqxe5o4().f[13]++;
  const sanitizedNum = (cov_25bxqxe5o4().s[80]++, value.replace(stripNonDigitPeriod, ''));
  const regex = (cov_25bxqxe5o4().s[81]++, sanitizedNum.indexOf('.') > -1 ? (cov_25bxqxe5o4().b[19][0]++, commaPositionsWithDecimal) : (cov_25bxqxe5o4().b[19][1]++, commaPositionsWithoutDecimal));
  cov_25bxqxe5o4().s[82]++;
  return sanitizedNum.replace(regex, '$&,');
};